export const environment = {
    production: true,
    devUserId: false, // 0 relates to the admin user id in the db

    sessionTimeout: 7200000, // 2 hrs in ms
    routeFolderPath: '/',
    classicCookieName: 'quantivate-c-e',
    apiTinymce: 'gej2d3h7ckhoptfrlrsfzc35irkr56ckcuzttq6j0zqroy6u',
    productTrackingUrl: 'https://productanalytics-feature09.ncontracts.com/api/registration',
    quantivateProductId: '24D08B4F-7393-48E9-8C9B-84F12E224049',

    enterpriseUrls: {
        apiEndpoint: 'https://devapi2.quantivate.com/api',
    },
    platformUrls: {
        api: 'https://devapi.quantivate.com', // the port you set in .env for platform
    },
    login: {
        retrieveBuild: true,
        // if retrieveBuild then just go to the following login page without looking for build in cookie
        externaloginPage: 'https://dev.quantivate.com/',
        externalogoutPage:
            'https://dev.quantivate.com/{buildName}/index.php?module=td_logout&mode=logout', // port set for platform
    },

    // UI setup to enable certain visible features
    disableUI: {
        // Enabling FE only beta features that arent ready for production but want to test
        // As the BE supports the feature, we will deprecate these
        enableBooleanLogic: false,
        enablePublishing: true,
        enableCMS: true,
        enablePreview: true,
        enableListChart: false,
        // feature flags are returned by the BE build, but in the case they arent, we can set them here
        // featureFlags :["dynamicChartColors", "dateGrouping"]
        featureFlags: [] as any[],
    },
};
